import { Paper, Stack, Typography, TypographyProps, useTheme } from '@mui/material';
import React from 'react';

export type BarChartTooltipItem = {
  label: string;
  value?: string;
  labelColor?: TypographyProps['color'];
  valueColor?: TypographyProps['color'];
  labelVariant?: TypographyProps['variant'];
  valueVariant?: TypographyProps['variant'];
};

export type CustomBarchartTooltipProps = {
  items: BarChartTooltipItem[];
};

export const BarChartTooltip = ({ items }: CustomBarchartTooltipProps) => {
  const { palette } = useTheme();
  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Stack direction='column'>
        {items.map(
          ({
            label,
            value,
            valueColor = palette.barChart.bar,
            labelColor,
            labelVariant,
            valueVariant,
          }) => (
            <Stack
              key={`${label}-${value}`}
              direction='row'
              justifyContent='space-between'
              spacing={2}
            >
              <Typography variant={labelVariant || 'body2'} color={labelColor}>
                {label}
              </Typography>

              {value !== null && value !== undefined && (
                <Typography variant={valueVariant || 'subtitle2'} color={valueColor}>
                  {value}
                </Typography>
              )}
            </Stack>
          ),
        )}
      </Stack>
    </Paper>
  );
};
